// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "wap/static/js/" + {"33":"playlist","187":"search","456":"savideo","484":"qlist","778":"hotsugg","962":"home"}[chunkId] + "." + {"33":"7f265869","187":"e3d80b67","456":"b1e7518f","484":"340fef09","778":"39bce805","962":"15af7bf4"}[chunkId] + ".js";
};